const MAX_CAUSE_LENGTH = 200;
const REPORTED_FIELDS = ['name', 'code', 'status', 'message'] as const;

const REDACTIONS: [RegExp, string][] = [
  [/\?[^\s'"]*/g, '?<redacted>'],
  [/[\w.+-]{1,64}@[\w-]{1,63}\.[\w.-]{1,63}/g, '<redacted>'],
  [/\b[\w-]{20,}\b/g, '<redacted>'],
  [/\b\d{12,}\b/g, '<redacted>'],
];

export function describeInitError(error: unknown): string {
  let cause: string;

  if (error instanceof Error) {
    cause = error.message || error.name;
  } else if (typeof error !== 'object' || error === null) {
    cause = String(error);
  } else {
    const source = error as Record<string, unknown>;

    cause = REPORTED_FIELDS
      .filter(field => source[field] !== undefined && source[field] !== null)
      .map(field => `${field}=${String(source[field])}`)
      .join(' ');
  }

  return REDACTIONS
    .reduce((text, [pattern, replacement]) => text.replace(pattern, replacement), cause || 'unknown error')
    .slice(0, MAX_CAUSE_LENGTH);
}
